module.exports = __webpack_public_path__ + "img/text_label.7887a935.png";